import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22.3333 12.5C22.3333 18.0228 17.8561 22.5 12.3333 22.5C6.8104 22.5 2.33325 18.0228 2.33325 12.5C2.33325 6.97715 6.8104 2.5 12.3333 2.5C17.8561 2.5 22.3333 6.97715 22.3333 12.5Z",
      fill: "#EAB308"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.3333 7.75C12.7475 7.75 13.0833 8.08579 13.0833 8.5V12.1893L15.3636 14.4697C15.6565 14.7626 15.6565 15.2374 15.3636 15.5303C15.0707 15.8232 14.5958 15.8232 14.3029 15.5303L11.8029 13.0303C11.6623 12.8897 11.5833 12.6989 11.5833 12.5V8.5C11.5833 8.08579 11.919 7.75 12.3333 7.75Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }